export const SET_FEEDBACK_BUSINESS_LOCATION_LOADING = "SET_FEEDBACK_BUSINESS_LOCATION_LOADING";
export const SET_FEEDBACK_BUSINESS_LOCATION = "SET_FEEDBACK_BUSINESS_LOCATION";
export const EDIT_FEEDBACK_BUSINESS_LOCATION = "EDIT_FEEDBACK_BUSINESS_LOCATION";